import React from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../hooks/useAuth';
import { Trophy, BarChart3, Download } from 'lucide-react';
import { Link } from 'react-router-dom';

export const HomePage: React.FC = () => {
  const { user, canScout, canViewAnalytics, isAdmin } = useAuth();

  const features = [
    {
      icon: Trophy,
      title: 'Scout Match Data',
      description: 'Enter detailed scouting information for each team with auto-save',
      link: '/scout',
      show: canScout,
    },
    {
      icon: BarChart3,
      title: 'Analytics Dashboard',
      description: 'View team rankings, performance trends, and predictions',
      link: '/analytics',
      show: canViewAnalytics,
    },
    {
      icon: Download,
      title: 'Export Reports',
      description: 'Download team data as Excel, CSV, or PDF reports',
      link: '/export',
      show: isAdmin,
    },
  ];

  const visibleFeatures = features.filter((f) => f.show);

  return (
    <div>
      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {visibleFeatures.map((feature, index) => (
          <motion.div
            key={feature.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Link to={feature.link}>
              <div className="glass p-6 h-full hover:border-blue-500/30 transition-all duration-200 cursor-pointer group">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-lg bg-blue-600/20 flex items-center justify-center group-hover:bg-blue-600/30 transition-colors">
                    <feature.icon className="w-6 h-6 text-blue-400" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-white mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-400">{feature.description}</p>
                  </div>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
